<template>
  <div class="worksmodal">
    <div class="overlay" @click="closemodal"></div>
    <div class="modalcontents">
      <div class="modalclosebtn" @click="closemodal">
        <span></span>
        <span></span>
      </div>
      <div class="modalcontents-inner">
        <div class="modalcontents-mainimg">
          <img
            v-if="list.headimg"
            :src="'images/' + list.id + '/gal/' + list.headimg"
          />
          <img v-else :src="'images/' + list.id + '/' + list.mainimg" />
        </div>
        <div class="modalcontents-tx">
          <h3>{{ name }}</h3>
          <h4>{{ list.maincopy }}</h4>
          <p v-html="list.contents" />
          <h5>主な設備</h5>
          <p v-html="list.equip" />
          <div class="modalcontents-tx-gal">
            <figure>
              <div class="imgwrap">
                <img
                  :src="'images/' + list.id + '/' + list.mainimg"
                  :alt="this.name"
                />
              </div>
            </figure>
            <figure v-for="(item, num) in list.archive" :key="num">
              <div class="imgwrap">
                <img
                  :src="'images/' + list.id + '/gal/' + item[0]"
                  :alt="item[1]"
                />
              </div>
              <figcaption>{{ item[1] }}</figcaption>
            </figure>
          </div>
        </div>
        <p class="closetext" @click="closemodal">ウインドウを閉じる</p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  disableBodyScroll,
  // enableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock";
export default {
  data() {
    return {};
  },
  mounted() {
    const modal = document.querySelector(".modalcontents-inner");
    disableBodyScroll(modal);
  },
  props: ["list", "name"],
  methods: {
    closemodal() {
      this.$emit("modalclose", false);
      clearAllBodyScrollLocks();
    },
  },
};
</script>
<style lang="scss" scoped>
// style
.worksmodal {
  padding: $h-gap;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  @include tb {
    padding: $v-gap $h-gap;
  }
  .overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .modalcontents {
    position: relative;
    width: 100%;
    height: 100%;
    max-width: 960px;
    .modalcontents-inner {
      border-radius: 2rem;
      background-color: white;
      height: 100%;
      overflow-y: scroll;

      scrollbar-width: none;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        display: none;
      }

      .modalcontents-mainimg {
        height: 45vmin;
        @include tb {
          height: 30vmax;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .modalcontents-tx {
        padding: clamp(0px, $h-gap, 2rem);
        h3 {
          font-size: 2rem;
          font-weight: bold;
          margin-bottom: 0.25em;
        }
        h4 {
          font-size: 1.2rem;
          font-weight: bold;
          color: $color_red;
          margin-bottom: 1.5rem;
        }
        h5 {
          display: inline-block;
          background-color: $color_blue;
          color: white;
          line-height: 2;
          padding: 0 0.5em;
          margin-right: 0.5em;
          margin-bottom: 0.5em;
          border-radius: 0.25em;
        }
        p {
          line-height: 1.5;
          margin-bottom: 2rem;
        }
        .modalcontents-tx-gal {
          display: grid;
          grid-gap: 2rem 1rem;
          grid-template-columns: repeat(2, 1fr);
          @include tb {
            grid-gap: 1rem;
            grid-template-columns: repeat(1, 1fr);
          }
          figure {
            position: relative;
            figcaption {
              bottom: 0;
              left: 0;
              width: 100%;
              padding: 0.5em;
              line-height: 1.5;
              font-size: 0.8em;
            }
          }
          .imgwrap {
            aspect-ratio: 3/2;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }
  }
  .closetext {
    font-weight: bold;
    background-color: $color_sub;
    cursor: pointer;
    padding: 2rem;
    width: 100%;
    text-align: center;
    color: white;
    transition: 0.2s;
    position: relative;

    &:hover {
      background-color: $color_blue;
    }
  }
  .modalclosebtn {
    position: absolute;
    right: -10px;
    top: -10px;
    background-color: $color_blue;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    z-index: 9999;
    transition: 0.5s;
    &:hover {
      background-color: white;
      span {
        background-color: $color_blue;
      }
    }
    span {
      position: absolute;
      display: block;
      background-color: white;
      width: 2px;
      height: 70%;
      left: calc(50% - 1px);
      top: 15%;
      transform-origin: center center;
      transition: 0.5s;
      &:nth-child(1) {
        transform: rotate(45deg);
      }
      &:nth-child(2) {
        transform: rotate(-45deg);
      }
    }
  }
}

//
.fade-enter-from {
  opacity: 0;
}

.fade-enter-to {
  opacity: 1;
}

.fade-enter-active {
  transition: all 0.25s ease-in-out;
}
.fade-leave-from {
  opacity: 1;
}

.fade-leave-to {
  opacity: 0;
}

.fade-leave-active {
  transition: opacity 0.25s ease-in-out;
}
</style>
